import { QueryClient } from "@tanstack/react-query";
import { toast } from "@win-reality/react-ui";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 3,
    },
    mutations: {
      onError: (error: unknown) => {
        let errorMessage;
        if (error instanceof Error) {
          try {
            const parsed = JSON.parse(error.message);
            if (parsed.detail) {
              errorMessage = parsed.detail;
            }
          } catch {
            errorMessage = error.message;
          }
        }

        if (!errorMessage) {
          errorMessage = "An unexpected error occurred";
        }

        toast(errorMessage, { variant: "error", duration: 6000 });
      },
    },
  },
});
